import React from "react";
import triggerHaptics, {FeedbackMessage, HapticType} from "../../../Common/Helper/triggerHaptics";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";

interface RefreshDialogProps {
    onClick: () => void;
    open: boolean;
}

const RefreshDialog = (props: RefreshDialogProps) => {
    const {onClick, open} = props;

    return (
        <Dialog
            open={open}
            onClose={onClick}
            onEntered={() => {
                triggerHaptics(HapticType.FeedBack, FeedbackMessage.Warning)
            }}
            onEnter={() => {
                // triggerHaptics(HapticType.FeedBack, FeedbackMessage.Success)
            }}
        >
            <DialogTitle>
                Refresh Page?
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    This action will refresh the entire page. If you need to refresh your JasperCard or Courses, you can use their refresh buttons. Do you want to continue?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    variant={'outlined'}
                    color={'secondary'}
                    onClick={onClick}
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => window.location.reload()}
                >
                    Refresh
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default RefreshDialog;